import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-face-compare',
  templateUrl: './face-compare.component.html',
  styleUrls: ['./face-compare.component.css']
})
export class FaceCompareComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
